import { useEffect, useRef, useState } from "react";

// Animates a number from 0 to `value` once; `format` renders the intermediate value
export function CountUp({ value = 0, format = (n) => Math.round(n), duration = 900 }) {
  const [n, setN] = useState(0);
  const raf = useRef();
  useEffect(() => {
    const target = Number(value) || 0;
    const start = performance.now();
    const step = (now) => {
      const p = Math.min(1, (now - start) / duration);
      setN(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration]);
  return <>{format(n)}</>;
}
